"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const testimonials = [];
  return;
}